import React from 'react'
import classNames from 'classnames'
import pretty from '@st-operations/uikit/lib/pretty'
import {
  OMM_REPORTS_STATUS_OPTIONS,
  OMM_STATUS_OPTIONS,
} from '../online-media-measurements/constants'

const MediaMeasurementCampaignsStatusBadge = ({ status }) => {
  return (
    <div
      className={classNames('rounded-md p-1 px-2 w-fit font-semibold text-sm', {
        'bg-primary text-gray-100':
          status === OMM_STATUS_OPTIONS.PROCESSED ||
          status === OMM_STATUS_OPTIONS.DELIVERED ||
          status === OMM_REPORTS_STATUS_OPTIONS.READY,
        'bg-secondary-100 text-primary':
          status === OMM_STATUS_OPTIONS.SUBMITTED_FOR_PROCESSING ||
          status === OMM_STATUS_OPTIONS.SUBMITTED_FOR_DELIVERY ||
          status === OMM_REPORTS_STATUS_OPTIONS.REQUESTED,
        'bg-gray-300 text-gray-700':
          status === OMM_STATUS_OPTIONS.PROCESSING ||
          status === OMM_STATUS_OPTIONS.DELIVERING ||
          status === OMM_REPORTS_STATUS_OPTIONS.GENERATING,
        'bg-[transparent] text-gray-400 border border-solid border-gray-400':
          status === OMM_STATUS_OPTIONS.DRAFT,
        'bg-[transparent] text-red-400 border border-solid border-red-400':
          status === OMM_STATUS_OPTIONS.INVALID || status === OMM_STATUS_OPTIONS.SIZE_LOW,
      })}
    >
      {pretty(status)}
    </div>
  )
}

export default MediaMeasurementCampaignsStatusBadge
